import React from 'react';
import { Link } from 'react-router-dom';

const resolveImageUrl = (url) => {
  if (!url) return '';

  const apiBaseUrl = process.env.REACT_APP_PUBLIC_API_URL || 'https://klinnovac.id/api';
  const apiOrigin = apiBaseUrl.replace(/\/api\/?$/, '');

  if (/^https?:\/\//i.test(url)) {
    try {
      const parsedUrl = new URL(url);
      if (parsedUrl.pathname.startsWith('/storage/')) {
        const isLocalHost = ['localhost', '127.0.0.1'].includes(parsedUrl.hostname);
        return isLocalHost ? `${apiOrigin}${parsedUrl.pathname}` : url;
      }
      return url;
    } catch (error) {
      return url;
    }
  }

  if (url.startsWith('/storage/') || url.startsWith('storage/')) {
    return `${apiOrigin}/${url.replace(/^\//, '')}`;
  }

  return url;
};

export default function ServicesSection({ content }) {
  const { title, subtitle, services } = content || {};

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-brand font-semibold text-sm uppercase tracking-wider">{subtitle || 'Layanan Kami'}</span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mt-3 mb-4" style={{ fontFamily: "'Cabin', sans-serif" }}>
            {title || 'Layanan Deep Cleaning'}
          </h2>
          <div className="w-16 h-1 mx-auto rounded-full" style={{ backgroundColor: '#66E0FF' }} />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {(services || []).map((service, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden group flex flex-col"
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden" style={{ backgroundColor: 'rgba(0,207,255,0.08)' }}>
                {service.image_url ? (
                  <img src={resolveImageUrl(service.image_url)} alt={service.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center" style={{ background: 'linear-gradient(135deg, rgba(0,207,255,0.2), rgba(0,200,232,0.15))' }}>
                    <span className="text-6xl">{service.icon || '🧹'}</span>
                  </div>
                )}
                {service.badge && (
                  <span className="absolute top-3 right-3 text-xs font-bold px-3 py-1 rounded-full" style={{ backgroundColor: '#66E0FF', color: '#081626' }}>
                    {service.badge}
                  </span>
                )}
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-brand-dark transition-colors">
                  {service.name}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-4 flex-1">
                  {service.short_description || service.description?.substring(0, 120) + '...'}
                </p>

                {/* Pricing */}
                {service.price && (
                  <div className="flex items-center gap-2 mb-4">
                    <span className="text-xl font-extrabold" style={{ color: '#081626' }}>
                      {service.price}
                    </span>
                    {service.price_unit && (
                      <span className="text-xs text-gray-400">{service.price_unit}</span>
                    )}
                  </div>
                )}

                {/* Features sneak peek */}
                {(service.features || []).length > 0 && (
                  <div className="mb-4 space-y-1">
                    {service.features.slice(0, 3).map((feat, j) => (
                      <div key={j} className="flex items-center gap-2 text-xs text-gray-600">
                        <svg className="w-4 h-4 flex-shrink-0" style={{ color: '#66E0FF' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <span>{typeof feat === 'string' ? feat : feat.label}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Actions */}
                <div className="flex gap-2">
                  <Link
                    to={service.slug ? `/services/${service.slug}` : `/services/${i}`}
                    className="flex-1 text-center text-sm font-semibold px-4 py-2.5 rounded-xl border transition-all hover:shadow-md"
                    style={{ borderColor: '#66E0FF', color: '#00CFFF' }}
                  >
                    Detail
                  </Link>
                  <Link
                    to={service.slug ? `/services/${service.slug}?order=true` : `/services/${i}?order=true`}
                    className="flex-1 text-center text-sm font-semibold px-4 py-2.5 rounded-xl transition-all hover:shadow-lg"
                    style={{ background: 'linear-gradient(135deg, #00CFFF, #66E0FF)', color: '#081626' }}
                  >
                    Pesan Sekarang
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Empty state */}
        {(!services || services.length === 0) && (
          <div className="text-center py-12 text-gray-400">
            <span className="text-5xl block mb-3">🧹</span>
            <p>Paket layanan akan ditampilkan di sini</p>
          </div>
        )}
      </div>
    </section>
  );
}